export default __webpack_public_path__ + "static/media/three-dots.9ef68b9e.svg";